import { useState, useEffect } from "react";
import { User } from "TypesAndInterfaces";

const useUser = () => {
  const [user, setUser] = useState<User>();

  useEffect(() => {
    const userString = localStorage.getItem("user");
    if (userString) {
      const user: User = JSON.parse(userString);
      setUser(user);
    }
  }, []);

  return user;
};
export default useUser;
